export default __webpack_public_path__ + "static/media/CSIO_BoardGrouping_2.afa5aa8c.png";